/**
 * --------------------------------------------------
 * !!! THIS FILE WAS GENERATED BY GRAPHQL-CODEGEN !!!
 * !!!   DO NOT MODIFY THIS FILE BY YOURSELF      !!!
 * --------------------------------------------------
 */

import * as c from "@hex/common";
import type * as Types from "../../../generated/graphqlTypes";

import { gql } from "@apollo/client";
import * as Apollo from "@apollo/client";
const defaultOptions = {} as const;
export type UpdateCollectionProjectRoleMutationVariables = Types.Exact<{
  projectRole: Types.InputMaybe<Types.ProjectRole>;
  hexId: Types.Scalars["HexId"]["input"];
  collectionId: Types.Scalars["CollectionId"]["input"];
}>;

export type UpdateCollectionProjectRoleMutation = {
  readonly __typename: "Mutation";
  readonly updateCollectionProjectRole: {
    readonly __typename: "CollectionHexLink";
    readonly id: c.CollectionHexLinkId;
    readonly projectRole: Types.ProjectRole | null;
  };
};

export const UpdateCollectionProjectRoleDocument = /*#__PURE__*/ gql`
  mutation UpdateCollectionProjectRole(
    $projectRole: ProjectRole
    $hexId: HexId!
    $collectionId: CollectionId!
  ) {
    updateCollectionProjectRole(
      projectRole: $projectRole
      hexId: $hexId
      collectionId: $collectionId
    ) {
      id
      projectRole
    }
  }
`;
export type UpdateCollectionProjectRoleMutationFn = Apollo.MutationFunction<
  UpdateCollectionProjectRoleMutation,
  UpdateCollectionProjectRoleMutationVariables
>;

/**
 * __useUpdateCollectionProjectRoleMutation__
 *
 * To run a mutation, you first call `useUpdateCollectionProjectRoleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCollectionProjectRoleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCollectionProjectRoleMutation, { data, loading, error }] = useUpdateCollectionProjectRoleMutation({
 *   variables: {
 *      projectRole: // value for 'projectRole'
 *      hexId: // value for 'hexId'
 *      collectionId: // value for 'collectionId'
 *   },
 * });
 */
export function useUpdateCollectionProjectRoleMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateCollectionProjectRoleMutation,
    UpdateCollectionProjectRoleMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    UpdateCollectionProjectRoleMutation,
    UpdateCollectionProjectRoleMutationVariables
  >(UpdateCollectionProjectRoleDocument, options);
}
export type UpdateCollectionProjectRoleMutationHookResult = ReturnType<
  typeof useUpdateCollectionProjectRoleMutation
>;
export type UpdateCollectionProjectRoleMutationResult =
  Apollo.MutationResult<UpdateCollectionProjectRoleMutation>;
export type UpdateCollectionProjectRoleMutationOptions =
  Apollo.BaseMutationOptions<
    UpdateCollectionProjectRoleMutation,
    UpdateCollectionProjectRoleMutationVariables
  >;
